import React from "react";
import { Box } from "@mui/material";

// Helpers compartilhados entre a página dedicada (/internal-chat) e a aba
// "Chat interno" dentro de Atendimentos. Um lugar só para não divergirem.

export const initials = name =>
  (name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join("")
    .toUpperCase();

export const formatTime = value => {
  if (!value) return "";
  const date = new Date(value);
  const today = new Date();
  const sameDay = date.toDateString() === today.toDateString();
  return sameDay
    ? date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
};

export const formatSize = bytes => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// Nome da conversa: grupo usa o título; conversa direta usa o nome do outro.
export const chatTitle = (chat, currentUserId) => {
  if (!chat) return "";
  if (chat.isGroup) return chat.title || "Grupo";
  const other = (chat.participants || []).find(
    p => Number(p.userId) !== Number(currentUserId)
  );
  return other?.user?.name || "Conversa";
};

export const myUnread = (chat, currentUserId) => {
  const me = (chat?.participants || []).find(
    p => Number(p.userId) === Number(currentUserId)
  );
  return me?.unreadMessages || 0;
};

export const isChatOnline = (chat, currentUserId) => {
  if (!chat || chat.isGroup) return false;
  const other = (chat.participants || []).find(
    p => Number(p.userId) !== Number(currentUserId)
  );
  return !!other?.user?.online;
};

// "#1234" no texto vira referência ao ticket. É o vínculo com o atendimento
// que o grupo de WhatsApp da equipe não consegue dar.
export const extractTicketId = text => {
  const match = /#(\d+)/.exec(text || "");
  return match ? Number(match[1]) : null;
};

export const parseMentions = value => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(Number) : [];
  } catch (err) {
    return [];
  }
};

// Resolve "@Fulano" escrito no texto para os ids dos participantes citados.
// Casar pelo nome completo evita ambiguidade entre "Ana" e "Ana Paula".
export const resolveMentions = (text, participants) => {
  const found = [];
  (participants || []).forEach(p => {
    const name = p.user?.name;
    if (name && text.includes(`@${name}`)) {
      found.push(Number(p.userId));
    }
  });
  return found;
};

// Quebra o texto para destacar as citações no balão.
export const renderBody = (text, participants) => {
  if (!text) return null;
  const names = (participants || [])
    .map(p => p.user?.name)
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);

  if (!names.length) return text;

  const escaped = names.map(n => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const regex = new RegExp(`(@(?:${escaped.join("|")}))`, "g");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    /^@/.test(part) && names.includes(part.slice(1)) ? (
      <Box
        key={index}
        component="span"
        sx={{ fontWeight: 700, textDecoration: "underline" }}
      >
        {part}
      </Box>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    )
  );
};
